export let keycloak;

function containsAny(arr1, arr2) {
  return arr1.some((item) => arr2.includes(item));
}

export function setAuthKeycloak(authKeycloak) {
  keycloak = authKeycloak;
}

export function getUserRoles() {
  const {roles} = keycloak.tokenParsed.resource_access["participant-registry"] || [];
  const userRolesSet = new Set(roles);
  return [...userRolesSet];
}

export const USER_ROLES = {
  REGISTRY_ADMIN: "admin",
  REGISTRY_PARTICIPANT: "participant",
  REGISTRY_VIEW_ONLY: "gb_member",
  REGISTRY_TECHNICAL: "technical_participant",
};

export const ALL_USERS = [...Object.values(USER_ROLES)];

export function isAllowed(user_roles) {
  if (!keycloak) {
    return false;
  }
  const result = containsAny(user_roles, getUserRoles());
  // console.log(item.user_roles, [...userRolesSet], result);
  return result;
}

// legal να κανεις update + retrieve τον participant και μονο retrieve τους connectors,
// ενω ως technical create/retrieve/update τους connector και μονο retrieve τον participant

export const USER_ACTIONS = {
  UPDATE_OWN_FORM: "View Own Registry Form",
  UPDATE_OWN_CONNECTOR: "create/retrieve/update connector",
  VIEW_PARTICIPANT_REGISTRY: "View PARTICIPANT Registry",
  ADMINISTER_PARTICIPANT_REGISTRY: "Administer PARTICIPANT Registry",
};

export function isAllowedAction(action) {
  switch (action) {
    case USER_ACTIONS.UPDATE_OWN_FORM:
      return containsAny(getUserRoles(), [USER_ROLES.REGISTRY_PARTICIPANT]);
      case USER_ACTIONS.UPDATE_OWN_CONNECTOR:
        return containsAny(getUserRoles(), [USER_ROLES.REGISTRY_TECHNICAL]);
    case USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY:
      return containsAny(getUserRoles(), [USER_ROLES.REGISTRY_ADMIN]);
    case USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY:
      return containsAny(getUserRoles(), [USER_ROLES.REGISTRY_VIEW_ONLY]);
    default:
      return false;
  }
}
